module.exports = __webpack_public_path__ + "img/14.8755b2fa.png";